import { Colors } from "@/enums/Colors";
import { Box, styled, Typography, useMediaQuery, useTheme } from "@mui/material";
import Image from "next/image";
import LazoLogo from "../../../assets/images/logo-lazo.svg";
import stepOneImage from "../../../assets/images/onboarding-steps/step-1.svg";
import stepTwoImage from "../../../assets/images/onboarding-steps/step-2.svg";
import stepThreeImage from "../../../assets/images/onboarding-steps/step-3.svg";

export const StepsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  height: "100%",
  alignItems: "center",
  justifyContent: "space-between",
  zIndex: 2,
  position: "relative",
  maxHeight: "100dvh",
  overflow: "auto",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "row",
    width: "95%",
  },
}));

interface OboardingStepsComponentProps {
  step: number;
}

export const OboardingStepsComponent = (props: OboardingStepsComponentProps) => {
  const { step } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: !isMobile ? "100%" : "50%",
        alignItems: "center",
        justifyContent: "space-between",
        zIndex: 2,
        position: "relative",
      }}
    >
      {isMobile ? (
        <img
          src={LazoLogo.src}
          style={{
            height: "50px",
            marginBottom: "5px",
          }}
        />
      ) : (
        <StepsContainer>
          {step === 0 && <FirstStep />}
          {step === 1 && <SecondStep />}
          {step === 2 && <ThirdStep />}
        </StepsContainer>
      )}
    </div>
  );
};

const FirstStep = () => {
  const under700 = window.innerHeight < 700;
  return (
    <Box
      sx={{
        marginTop: "8.6%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <TextStyled
        sx={{
          color: Colors.WHITE,
        }}
      >
        AI-powered
        <br />
        <span style={{ color: Colors.LAZO_PURPLE }}>startup operations</span>
      </TextStyled>
      <TextStyled
        sx={{
          color: Colors.WHITE,
          marginTop: "16px",
        }}
      >
        To propel your company’s growth 🚀
      </TextStyled>
      <Image
        src={stepOneImage.src}
        width={under700 ? 312 : 390}
        height={under700 ? 290 : 363}
        style={{ marginTop: "8.6%" }}
        alt="Lazo onboarding step one"
      />
      <TextStyled
        sx={{
          color: Colors.WHITE,
          marginTop: "8.6%",
        }}
      >
        We are your trusted co-pilot.
        <br />
        We are <span style={{ color: Colors.LAZO_PURPLE }}>Lazo One.</span>
      </TextStyled>
    </Box>
  );
};
const SecondStep = () => {
  const under700 = window.innerHeight < 700;
  return (
    <Box
      sx={{
        marginTop: "12.2%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <TextStyled
        sx={{
          color: Colors.WHITE,
        }}
      >
        We know that the entrepreneurial
        <br />
        <span style={{ color: Colors.LAZO_PURPLE }}>journey is hard.</span>
      </TextStyled>
      <Image
        src={stepTwoImage.src}
        width={under700 ? 356 : 484}
        height={under700 ? 250 : 340}
        alt="Lazo onboarding step two"
        style={{ marginTop: "8.7%" }}
      />
      <TextStyled
        sx={{
          color: Colors.WHITE,
          marginTop: "5.4%",
        }}
      >
        <span style={{ color: Colors.LAZO_PURPLE }}>Lazo AI</span> is here to support you every
        <br />
        step of the way, 24hrs a day,
        <br />7 days a week.
      </TextStyled>
    </Box>
  );
};
const ThirdStep = () => {
  const under700 = window.innerHeight < 700;
  return (
    <Box
      sx={{
        marginTop: "14%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <TextStyled
        sx={{
          color: Colors.WHITE,
        }}
      >
        Get <span style={{ color: Colors.LAZO_PURPLE }}>actionable business insights</span>
        <br />
        simply by connecting your data to
        <br />
        our system.
      </TextStyled>
      <Image
        src={stepThreeImage.src}
        width={512}
        height={315}
        alt="Lazo onboarding step three"
        style={{ marginTop: under700 ? "5.4%" : "8.7%" }}
      />
      <TextStyled
        sx={{
          color: Colors.WHITE,
          marginTop: under700 ? 0 : "5.4%",
        }}
      >
        Fill out your activity to get an
        <br />
        <span style={{ color: Colors.LAZO_PURPLE }}>instant quote.</span>
      </TextStyled>
    </Box>
  );
};

const TextStyled = styled(Typography)`
  font-weight: 600;
  font-size: 28px;
  line-height: 33.6px;
  text-align: center;
`;
